import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询预付款余额
export function queryBalanceList(requestBody) {
  return request({
    url: URL.act.advancePayment.queryBalanceListUrl,
    method: 'post',
    data: requestBody
  })
}

// 查询余额变动明细
export function queryDetailList(requestBody) {
  return request({
    url: URL.act.advancePayment.queryDetailListUrl,
    method: 'post',
    data: requestBody
  })
}

// 查询业财余额
export function queryFinanceBalanceList(requestBody) {
  return request({
    url: URL.act.advancePayment.queryFinanceBalanceListUrl,
    method: 'post',
    data: requestBody
  })
}

// 预存款客户信息同步推送
export function pushCustomerInfo(requestBody) {
  return request({
    url: URL.act.advancePayment.pushCustomerInfoUrl,
    method: 'post',
    data: requestBody
  })
}

// 预存款客户信息查询
export function queryCustomerInfo(requestBody) {
  return request({
    url: URL.act.advancePayment.queryCustomerInfoUrl,
    method: 'post',
    data: requestBody
  })
}

// 业财预存款余额查询
export function queryInitializeBalance(requestBody) {
  return request({
    url: URL.act.advancePayment.queryInitializeBalanceUrl,
    method: 'post',
    data: requestBody
  })
}

// 业财预存款余额查询:初始化余额
export function saveInitializeBalance(requestBody) {
  return request({
    url: URL.act.advancePayment.saveInitializeBalanceUrl,
    method: 'post',
    data: requestBody
  })
}
